import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter, Routes } from 'react-router-dom';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./js/bootstrap";
import "./js/helpers";
import "./js/menu";
import "react-toastify/dist/ReactToastify.css";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { ToastContainer } from 'react-toastify';
import { NotificationProvider } from './services/NotificationContext';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
 <NotificationProvider>
  
  <React.StrictMode>
 <BrowserRouter>
 
    <App />
    <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick={false}
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
 
/>
 
 </BrowserRouter>
 
  </React.StrictMode>
</NotificationProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
